import {QueryClient} from '@tanstack/react-query';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      refetchOnMount: false,
    },
  },
});

export default client;
